angular.module('leanlaw').directive('llInvoiceTableColumn', [function () {
  return {
    restrict: 'EA',
    require: 'ngModel',
    scope: {
      include: '=ngModel',
      inactive: '='
    },
    link(scope, element, attrs, ngModel) {
      element.append("<i class='fa'></i>");
      element.addClass('selectable-column');
      element.bind('click', () => {
        scope.include = !scope.include;
        includeChange(scope.include);
      });
      scope.$watch('include', includeChange);
      function includeChange(include) {
        element.find('.fa').removeClass('fa-square');
        element.find('.fa').removeClass('fa-check-square');
        element.removeClass('included');
        if (include) {
          element.addClass('included');
          element.find('.fa').addClass('fa-check-square');
        } else {
          element.find('.fa').addClass('fa-square');
        }
        ngModel.$setViewValue(include);
      }
    }
  };
}]);